import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

/**
 * 배송 토글 ON 상태에서 결과 0건일 때 노출되는 "오늘출발 보러가기" CTA 클릭 로깅.
 * iOS `FolderDetailEmptyCell` / Android `FolderEmptyView`의 TodayEmptyView와 동일.
 * SCREEN 은 AnalyticsScreen context 에서 자동 주입.
 */
export const useLogClickTodayDelivery = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_TODAY_DELIVERY' });
  }, [logAnalyticsEvent]);
};
